module.exports = __webpack_public_path__ + "site/img/55.baf68fae.jpg";